var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "20 20 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.6813 76.5151C77.6813 76.8631 77.5073 77.1969 77.1975 77.443C76.8878 77.6891 76.4678 77.8273 76.0298 77.8273H52.9089C52.5456 77.8273 52.1988 78.0898 51.9015 78.2604L46.303 81.7639V60.7686C46.303 60.4206 46.477 60.0869 46.7867 59.8408C47.0964 59.5947 47.5165 59.4564 47.9545 59.4564H54.3292V56.832H47.9545C46.6405 56.832 45.3803 57.2468 44.4511 57.985C43.522 58.7233 43 59.7246 43 60.7686V84.3884C43.0025 84.6321 43.0903 84.8704 43.2536 85.0767C43.417 85.2829 43.6494 85.449 43.9248 85.5562C44.1902 85.6521 44.4828 85.6905 44.7728 85.6674C45.0629 85.6444 45.3401 85.5607 45.5763 85.425L54.0815 80.4517H76.2775C76.9034 80.4664 77.5265 80.3789 78.1081 80.1945C78.6897 80.0101 79.2175 79.7328 79.6587 79.3797C80.0999 79.0267 80.4453 78.6054 80.6733 78.142C80.9013 77.6786 81.0071 77.1829 80.9842 76.6857V75.2029H77.6813V76.5151Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8671 47H63.6669C62.347 47 61.0813 47.4256 60.148 48.1832C59.2147 48.9408 58.6904 49.9683 58.6904 51.0396V67.1982C58.6904 68.2696 59.2147 69.2971 60.148 70.0547C61.0813 70.8123 62.347 71.2379 63.6669 71.2379H86.1441L94.0733 76.2336C94.309 76.3751 94.5867 76.4633 94.8781 76.4893C95.1695 76.5153 95.4642 76.4782 95.7322 76.3817C96.0144 76.2726 96.253 76.1009 96.4203 75.8865C96.5876 75.6721 96.6768 75.4236 96.6777 75.1698V51.0396C96.6784 49.9912 96.1769 48.9836 95.2792 48.2298C94.3815 47.4759 93.158 47.0349 91.8671 47ZM93.5259 72.5037L87.72 68.8276C87.4304 68.6452 87.0746 68.5457 86.7081 68.5448H63.6669C63.2269 68.5448 62.805 68.4029 62.4939 68.1504C62.1828 67.8979 62.0081 67.5554 62.0081 67.1982V51.0396C62.0081 50.6825 62.1828 50.34 62.4939 50.0875C62.805 49.835 63.2269 49.6931 63.6669 49.6931H91.8671C92.3105 49.7258 92.7239 49.8889 93.0294 50.1518C93.335 50.4147 93.5115 50.7592 93.5259 51.1204V72.5037Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_359_27",
    x: 0,
    y: 0,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.166111 0 0 0 0 0.658567 0 0 0 0 0.766667 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_359_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_359_27",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.a3af1e32965ea05ea448c0154b77a2b6.svg";
export { ForwardRef as ReactComponent };